module.exports = __webpack_public_path__ + "img/capture-multiple.30a04a45.gif";